import React from 'react';
import getSrpUrlParams from '@stencil/flights-utils/src/get-srp-url-params';
import * as S from './fare-table.styles';
import isSEM from '@stencil/flights-utils/src/is-sem';
import { SEO_SEARCH_STRING } from '@stencil/flights-constants/src/default-values';

const FareTableData = ({ fareInfo, flightSearchData, searchParams = '' }) => {
  const SRP_URL: string = `/flights/air-`;
  const { title, fare, date } = fareInfo;
  const dateStr = date && date.dateToDisplay ? date.dateToDisplay.substring(0, 6) : '-';
  const actionHandler = () => {
    const isSem = isSEM();
    const searchString = isSem ? location?.search : `?${SEO_SEARCH_STRING}`;
    const srpURLParams = getSrpUrlParams({ ...flightSearchData, departure: date });
    window.location.href = `${window.location.origin}${SRP_URL}${srpURLParams}/${searchString}${searchParams}`;
  };
  return (
    <tr>
      <td>{title}</td>
      {fare === '-' ? (
        <td>{fare}</td>
      ) : (
        <td>
          <i className="rs">Rs</i> {`${fare}`}
        </td>
      )}
      <td onClick={actionHandler}>
        <div className="hit">{dateStr}</div>
      </td>
    </tr>
  );
};

const FareTable = props => {
  const { title, minfare, flightSearchData, isDweb = false, searchParams = '' } = props;
  const {
    minToday,
    minIn30Days,
    minPriceIn90Days,
    todayDate,
    minDepDateIn30Days,
    minDepDateIn90Days,
    minFareInYear,
    minDepDateInYear
  } = minfare;

  const fareInfoArray = [
    {
      title: 'Lowest Airfare Today',
      fare: minToday,
      date: todayDate
    },
    {
      title: 'Cheapest Fare Within 30 Days',
      fare: minIn30Days,
      date: minDepDateIn30Days
    },
    {
      title: 'Cheapest Fare Within 90 Days',
      fare: minPriceIn90Days,
      date: minDepDateIn90Days
    },
    {
      title: 'Cheapest Fare Within 365 Days',
      fare: minFareInYear,
      date: minDepDateInYear
    }
  ];

  return (
    <S.FareWrap isDweb={isDweb}>
      <S.FareContent>
        <table className="table">
          <thead>
            <tr>
              <th>{title}</th>
              <th>Fare</th>
              <th>Date</th>
              {/* <th>Airline</th>
                <th></th> */}
            </tr>
          </thead>
          <tbody>
            {fareInfoArray.map((fareInfo, index) => (
              <FareTableData
                key={index}
                fareInfo={fareInfo}
                flightSearchData={flightSearchData}
                searchParams={searchParams}
              />
            ))}
          </tbody>
        </table>
      </S.FareContent>
    </S.FareWrap>
  );
};

export default FareTable;
